import Vue from 'vue';
import App from './App.vue';
import router from './router';
import globalConfig from './utils/common';
import Vant from 'vant';
import 'vant/lib/index.css';
import store from './store';
Vue.use(Vant);
import VueMeta from 'vue-meta';
import ScrollTopOnImg from '@/plugins/scrollTopOnImg';

Vue.use(ScrollTopOnImg, {
  imgClass: 'new-icon', // 你统一的图片类名
});

Vue.use(VueMeta);

Object.keys(globalConfig).forEach(key => {
  Vue.prototype[`$${key}`] = globalConfig[key];
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
